import { AWS_API_URL } from 'global/environment';
import { authorize, getRequest } from 'utils/http';

const backendURL = `${AWS_API_URL}/resources`;

export async function getLaundrySchedules(resourceId) {
  const url = `${backendURL}/${resourceId}/schedules`;
  return getRequest(url, await authorize());
}
